export default __webpack_public_path__ + "static/media/moreInfoPdf.f0a20e58.gif";